const GatewayActions = {
  LOADED_LIST: "LOADED_GATEWAYS_LIST",
  LOADED_GATEWAY: "LOADED_GATEWAY",
  CREATED_GATEWAY: "CREATED_GATEWAY",
  UPDATED_GATEWAY: "UPDATED_GATEWAY",
  DELETED_GATEWAY: "DELETED_GATEWAY",
};

export default GatewayActions;
